module.exports = __webpack_public_path__ + "static/media/IMG_1456.1394c957.JPG";